import createReducer from 'base/shared/createReducer';

import { parseCities } from './utils';

import Types from './types';
import { HomeModel } from './models';

const homeError = (state, action) => ({
  ...state,
  fetching: false,
  fetched: false,
  error: action.error,
});

const homeRequest = (state) => ({
  ...state,
  fetching: true,
  fetched: false,
  error: null,
});

const homeSuccess = (state, action) => {
  const {
    data: { cities },
    metadata,
  } = action.result;
  const featuredCities = parseCities(cities.other);
  const topRooms = parseCities(cities.top);
  const mainCity = topRooms.length ? topRooms[0] : null;

  return {
    ...state,
    fetching: false,
    fetched: true,
    countryCode: metadata.user_location,
    error: null,
    isDefault: metadata.default_home,
    mainCity,
    featuredCities,
  };
};

const badiPlusCollectionRequest = (state) => ({
  ...state,
  badiPlusCollectionLoading: true,
  badiPlusCollectionError: null,
});

const badiPlusCollectionSuccess = (state, action) => ({
  ...state,
  badiPlusCollection: action.result,
  badiPlusCollectionLoading: false,
  badiPlusCollectionError: null,
});

const badiPlusCollectionError = (state, action) => ({
  ...state,
  badiPlusCollectionLoading: false,
  badiPlusCollectionError: action.error,
});

const roomCollectionsByPlaceIdsRequest = (state) => ({
  ...state,
  roomCollectionsByPlaceIdsLoading: true,
  roomCollectionsByPlaceIdsError: null,
});

const roomCollectionsByPlaceIdsSuccess = (state, action) => ({
  ...state,
  roomCollectionsByPlaceIds: action.result,
  roomCollectionsByPlaceIdsLoading: false,
  roomCollectionsByPlaceIdsError: null,
});

const roomCollectionsByPlaceIdsError = (state, action) => ({
  ...state,
  roomCollectionsByPlaceIdsLoading: false,
  roomCollectionsByPlaceIdsError: action.error,
});

const actionHandlers = {
  [Types.HOME_ERROR]: homeError,
  [Types.HOME_REQUEST]: homeRequest,
  [Types.HOME_SUCCESS]: homeSuccess,
  [Types.BADI_PLUS_COLLECTION_REQUEST]: badiPlusCollectionRequest,
  [Types.BADI_PLUS_COLLECTION_SUCCESS]: badiPlusCollectionSuccess,
  [Types.BADI_PLUS_COLLECTION_ERROR]: badiPlusCollectionError,
  [Types.ROOM_COLLECTIONS_BY_PLACE_IDS_REQUEST]: roomCollectionsByPlaceIdsRequest,
  [Types.ROOM_COLLECTIONS_BY_PLACE_IDS_SUCCESS]: roomCollectionsByPlaceIdsSuccess,
  [Types.ROOM_COLLECTIONS_BY_PLACE_IDS_ERROR]: roomCollectionsByPlaceIdsError,
};

export default createReducer(actionHandlers, { ...HomeModel });
